import React, { useEffect, useState } from 'react';
import { InputSearchGray, Layout, ScrollItemNews } from '../../../components';
import DynamicFaIcon from '../../../components/atoms/DynamicFaIcon';
import { Link, useNavigate } from 'react-router-dom';
import CarouselNews from '../../../components/moleculs/Carousel/CarouselNews';
import { useDispatch } from 'react-redux';
import { postDataPage, setPageNo, setPageSize } from '../../../redux/newsSlice';

const News = () => {
	const [keyword, setKeyword] = useState('');
	const navigator = useNavigate();
	const dispatch = useDispatch<any>();

	const getNewsList = async (page: number, pageSize: number) => {
		const params = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'name',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'and',
				},
				{
					key: 'headline',
					value: false,
					operation: 'EQUAL',
					conjunction: 'and',
				},
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: 'and',
				},
			],
		};
		dispatch(postDataPage(params));
		dispatch(setPageNo(page));
		dispatch(setPageSize(pageSize));
	};

	useEffect(() => {
		getNewsList(0, 10);
	}, []);

	return (
		<Layout
			showNavBar={false}
			showNavigation={true}
		>
			<div className="my-5">
				<div className="flex gap-5 justify-between items-center ">
					<InputSearchGray
						value={keyword}
						onChange={(e) => {
							setKeyword(e.target.value);
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								navigator(`/admin/news/all?keyword=${encodeURI(keyword)}`);
							}
						}}
						icon={'FaSistrix'}
						placeholder="Cari Informasi Berita"
					/>
					<button>
						<DynamicFaIcon name={'FaBell'} />
					</button>
				</div>
				<div className="mt-5">
					<div className="flex justify-between mb-4">
						<h1 className="text-[12px]">Trending</h1>
						<Link
							className="text-[12px]"
							to={'/admin/news/all'}
						>
							Lihat Semua
						</Link>
					</div>
					<CarouselNews />
				</div>
				<div className="mt-5">
					<ScrollItemNews
						keyword={keyword}
						fix={true}
					/>
				</div>
			</div>
		</Layout>
	);
};

export default News;
